import { render, staticRenderFns } from "./VerticalMedia.vue?vue&type=template&id=80082e70"
import script from "./VerticalMedia.vue?vue&type=script&lang=js"
export * from "./VerticalMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports